define('view/module/AdaCompliantView',['require','lib/view/FormView','lib/view/UnwrapBehavior','Config','lib/Navigation'],function (require) {

    var FormView = require('lib/view/FormView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');
    var Navigation = require('lib/Navigation');

    return FormView.extend({

        template: '#ada_compliant_module',

        modelEvents:  {
            'sync': 'render',
            'change': 'render',
            'invalid' : 'render'
        },

        ui: {
            data : ':input',
        },

        events : {
            'click a.ada-compliance__btn': '_onSwitchClick'
        },

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        lastData : null,
        sendCounter : 0,

        initialize: function (options) {
            var _this = this;

            // the switch links keep the current page: re-render on every navigation
            this.listenTo(Backbone.history, 'route', function () {
                if (!_this.isDestroyed) {
                    _this.render();
                }
            });
            if (!Navigation.isPathMode()) {
                window.addEventListener("hashchange", function (){
                    _this.render();
                });
            }
        },

        _makeUrl : function (isAda){
            var config = Config.getInstance();
            var route = Navigation.routeFragment();
            var customQuery = null;
            if(config.getOption('custom_query')){
                customQuery = config.getOption('custom_query');
            }
            var query = '?ada=' + (isAda?1:0) + (customQuery?'&'+customQuery:'');
            if (Navigation.isPathMode()) {
                // '/v2/<route>/' (encoded the same way as the in-app links), the query is replaced
                return Navigation.url(route).split('?')[0] + query;
            }
            return  '/v2/' + query + (route?'#' + route:'');
        },

        // the server switches the theme: always a full page load, never an in-app navigation
        _onSwitchClick: function (evt) {
            var href = $(evt.currentTarget).attr('href');
            if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) {
                return; // new tab / window: the browser opens the link itself
            }
            if (href) {
                evt.preventDefault();
                window.location.href = href;
            }
        },

        serializeData: function () {
            var config = Config.getInstance();
            var res = this._serializeData();
            res = _.extend(res, {
                'ada_theme_url' : this._makeUrl(true),
                'base_theme_url' : this._makeUrl(false),
                'is_ada_compliant' : config.getOption('is_ada_compliant'),
                'is_widget' : config.getOption('is_widget'),
                'enabled' : this.model.get('enabled'),
            })
            return res;
        },



    });
});

